import { useState, useEffect } from 'react';

// ─── Navegación con teclado en buscadores de selección (sesión 34) ───────────
// ↑ ↓ mueven la opción resaltada, Enter elige, Esc cierra la lista. La primera opción queda resaltada al
// escribir, así que "escribir + Enter" elige el primer resultado. Uso:
//   const tecla = useTecladoLista(resultados, elegir, cerrar);
//   <input onKeyDown={tecla.onKeyDown} ... />
//   resultados.map((r, i) => <div style={i === tecla.activo ? RESALTADO : {}} onMouseEnter={() => tecla.setActivo(i)} ...>)
export const ESTILO_ACTIVO = { background: 'rgba(83,74,183,0.22)' };

export default function useTecladoLista(items, onElegir, onCerrar) {
  const [activo, setActivo] = useState(0);
  const firma = (items || []).map(x => x?.id ?? '').join('|');
  useEffect(() => { setActivo(0); }, [firma]);

  const onKeyDown = (e) => {
    const n = (items || []).length;
    if (e.key === 'Escape') { if (onCerrar) { e.preventDefault(); onCerrar(); } return; }
    if (!n) return;
    if (e.key === 'ArrowDown') { e.preventDefault(); setActivo(i => (i + 1) % n); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); setActivo(i => (i - 1 + n) % n); }
    else if (e.key === 'Enter') {
      const item = items[Math.min(activo, n - 1)];
      if (item) { e.preventDefault(); onElegir(item); }
    }
  };
  return { activo, setActivo, onKeyDown };
}
